import {
    GET_PROJECT,
    GET_PROJECT_SUCCESS,
    GET_PROJECT_FAIL,
} from '../../../constants/actions/project.constants';

export default function (
    state = { isLoading: false, isLoaded: false },
    action: { type: string },
) {
    switch (action.type) {
        case GET_PROJECT:
            return { ...state, isLoading: true };
        case GET_PROJECT_SUCCESS:
            return { isLoading: false, isLoaded: true };
        case GET_PROJECT_FAIL:
            return { ...state, isLoading: false };

        default:
            return state;
    }
}
